import { AuthContext } from "@sagecentral/core-ui";
import AuthHelperUI from "./AuthHelperUI";
import { useContext, useEffect } from "react";

const SignOutCallback = () => {
    const auth = useContext(AuthContext);

    useEffect(() => {
        if (auth === null) return;
        auth.logout();
    }, [ auth ]);

    return (
        <AuthHelperUI>Logging you out.</AuthHelperUI>
    );
};

export default SignOutCallback;